export default __webpack_public_path__ + "images/e8835991aed6127f602236d7ade839a5-international_affairs.jpg";